import React from 'react';
import Color from 'swag-client-common/components/ui/color';
import classes from './color-section.scss';
const CheckboxSection = ({
  filterData,
  selectedFilter,
  onClickCheckbox,
  isDisabled,
  color
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.wrapper,
  "data-block": "ColorsFilter"
}, filterData.map(data => {
  const isChecked = !!(selectedFilter && selectedFilter.indexOf(data.id) !== -1);
  return /*#__PURE__*/React.createElement(Color, {
    customColor: color,
    className: classes.color,
    activeClassName: classes.active,
    name: data.name,
    key: data.id,
    color: data.id,
    isActive: isChecked,
    tooltipText: data.name,
    onClick: () => onClickCheckbox(data.id),
    isDisabled: isDisabled,
    showTooltip: true
  });
}));
export default CheckboxSection;